const selectAndCompare = (select, lang) => {
  select.addEventListener("change", function (event) {
    const selectedVal = event.target.value;

    fetch(`${admin_ajax.url}?lang=${lang}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "handle_compare_property_selected_value",
        nonce: admin_ajax.nonce,
        selected_value: selectedVal,
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        document.getElementById("property-compare-result").innerHTML = data;
      })
      .catch((error) => {
        console.error("Ajax request failed:", error);
      });
  });
};

const init = (selectWrapper) => {
  if (!selectWrapper) {
    return;
  }

  const lang =
    {
      fi: "fi",
      "en-US": "en",
      "sv-SE": "sv",
    }[document.documentElement.lang] || "fi";

  const select = selectWrapper.querySelector(
    'select[name="select-property-and-compare"]',
  );
  selectAndCompare(select, lang);
};

export default init;
